import React, { useContext } from "react";
import { LanguageContext } from "../components/LanguageContext";
import ah6 from '../images/ah9.jpeg';

const Footer = () => {
  const { language } = useContext(LanguageContext);
  const currentYear = new Date().getFullYear();
  
  const directors = [
    {
      id: 1,
      name: 'Janab D. Nijauddin',
      designation: 'Director / Secretary AP State Urdu Academy',
    },
    {
      id: 2,
      name: 'Janab Ch. Sridhar IAS',
      designation: 'Secretary To The Government Minorities Welfare Department AP',
      image: ah6
    }
  ];

  return (
    <>
      <footer className="bg-blue-900 text-white py-8">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-center items-center gap-8 mb-6">
            {directors.map((director) => (
              <div key={director.id} className="flex flex-col items-center">
                {director.image && (
                  <div className="w-20 h-20 mb-3">
                    <img
                      src={director.image}
                      alt={director.name}
                      className="w-full h-full rounded-full object-fit border-2 border-white"
                    />
                  </div>
                )}
                <div className="text-center max-w-xs">
                  <h3 className="font-semibold text-lg mb-1">{director.name}</h3>
                  <p className="text-gray-300 text-sm">{director.designation}</p>
                </div>
              </div>
            ))}
          </div>
          <div className="text-sm md:text-base text-center text-gray-300 border-t border-gray-700 pt-6">
            <p className="px-2">
              &copy; {currentYear} {language === 'en' ? "AP State Urdu Academy. All rights reserved." : "اے پی اسٹیٹ اردو اکیڈمی۔ جملہ حقوق محفوظ ہیں۔"}
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
